import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types';
import Moment from 'moment-timezone';


import { Col, FormGroup, Label, Row, DefaultTable, DefaultSheet, SheetBody, ButtonIcon } from 'twyne-new.ui';
import { Search } from 'lucide-react';
import DefaultTableResize from '@/components/DefaultTableResize_';
import { TruncateWithTooltipFormatter } from '@/components/Grid/components/Table/formatters';

const mapValues = {
  fraudVerification: {
    '-1': `not verified`,
    '1': `fraud`,
    '0': `not fraud`
  },
  botVerification: {
    '-1': `not verified`,
    '1': `not bot`,
    '0': `bot`
  },
  checkers: {
    '-1': `not verified`,
    '1': `valid`,
    '0': `invalid`
  }
};

const validKeysToConvert = [
  'fraudVerification',
  'botVerification',
  'addressVerification',
  'emailVerification',
  'postalVerification',
  'phoneVerification',
];

const formatValue = (label, value) => {
  if (!value) return '--';
  if (['created_at', 'updated_at'].includes(label)) {
    return formatDates(value);
  }
  if (label === 'meta')
    return JSON.stringify(value, null, 2);
  if (validKeysToConvert.includes(label)) {
    if (label in mapValues) {
      return mapValues[label][value]
    } else {
      return mapValues['checkers'][value]
    }
  }

  return value;
}

const formatDates = (cell, row) => {
  return Moment(cell).format('MMM DD, YYYY - hh:mm A')
}

function ReportsAllocationTable({ data }) {
  const [allocationData, setAllocationData] = useState(null)

  const allocationById = useCallback(row => {
    setAllocationData(row)
  }, [])

  const allocationDataDetailsToggle = useCallback(() => {
    setAllocationData(null)
  }, [])

  const renderActions = useCallback((_, row) => <ButtonIcon
    content='Details'
    onClick={() => allocationById(row)}
  >
    <Search size={16} />
  </ButtonIcon>, [allocationById])

  const columns = [
    {
      dataField: 'created_at',
      text: 'Created at',
      formatter: cell => formatDates(cell),
      size: 200,
    },
    {
      dataField: 'allocationId',
      text: 'Allocation ID',
    },
    {
      dataField: 'publisherId',
      text: 'Publisher ID',
    },
    {
      dataField: 'payouttype',
      text: 'Payout type',
    },
    {
      dataField: 'conversiontype',
      text: 'Conversion type',
    },
    {
      dataField: 'originalUrl',
      text: 'Original URL',
      formatter: cell => <TruncateWithTooltipFormatter value={cell} />,
      size: 300,
    },
    {
      dataField: 'id',
      text: '',
      maxWidth: 50,
      formatter: renderActions,
    },
  ]

  const rows = Array.isArray(data) ? data : []

  return <>
    <DefaultTableResize
      keyField='id'
      data={rows}
      columns={columns}
      noDataIndication={() => 'No allocations to show.'}
    />
    <AllocationResultDetails allocationData={allocationData} toggle={allocationDataDetailsToggle} />
  </>
}

function AllocationResultDetails({ allocationData, toggle }) {
  const isOpen = Boolean(allocationData)
  if (!isOpen) {
    return null;
  }
  const data = Object.entries(allocationData);

  return <DefaultSheet
    title='Allocation Details'
    trigger={<></>}
    wrapperProps={{ open: isOpen, onOpenChange: toggle }}
  >
    <SheetBody>
      <Row>
        {data.map(([key, value], index) => <Col size={6} key={index}>
          <AllocationResultBodyItem label={key} value={value} />
        </Col>)}
      </Row>
    </SheetBody>
  </DefaultSheet>
}

function AllocationResultBodyItem({ label, value }) {
  const display = formatValue(label, value);

  return <>
    <FormGroup>
      <Label>{label}</Label>
      {label === 'meta' ? <pre>{display}</pre> : <>
        <TruncateWithTooltipFormatter value={display} />
      </>}
    </FormGroup>
  </>
}

ReportsAllocationTable.propTypes = {
  data: PropTypes.object,
  allocationById: PropTypes.func,
  dates: PropTypes.any,
};
AllocationResultDetails.propTypes = {
  allocationData: PropTypes.object,
  toggle: PropTypes.func
};
AllocationResultBodyItem.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  sm: PropTypes.string,
  md: PropTypes.string
};
AllocationResultBodyItem.defaultProps = {
  sm: '3',
  md: '2'
}

export default ReportsAllocationTable;
